import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const HubDelinquentTooltip = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "account-and-billing-components.TurnAutoRenewalOnButton.hub-delinquent-tooltip"
    }),
    maxInlineSize: "160px",
    children: children
  });
};
export default HubDelinquentTooltip;